import React, { useEffect, useState } from 'react';
import axios from 'axios';
import 'babel-polyfill';
import { formatPhone, useSearchParams } from './util';
import { IProvider } from './interfaces';
import FormWrapper from './formwrapper';
import { labels } from './labels';

const ContactProvider = () => {    
    const [npi, deptid, error, reason, backto] = useSearchParams(["npi", "deptid", "error", "reason", "backto"]);
    
    const [loading, setLoading] = useState(true);
    const [provider, setProvider] = useState<IProvider>();

    useEffect(() => {
        axios.get(`api/providers/${npi}?deptid=${deptid}`)
            .then((result) => {
                setProvider(result.data);
                setLoading(false)
            }).catch(() => {
                setLoading(false);
            })
    }, [])

    var content = <div></div>;

    if (loading) {
    } else if (!provider) {
        content = labels.contactprovider.unexpectedError;
    } else if (error === "POSSIBLE_BOT") {
        content = content = labels.contactprovider.possibleBot;
    } else if (error === "INVALID_APPT") {
        content = labels.contactprovider.invalidAppt(provider.firstName + " " + provider.lastName + (provider.academicTitle ? (", " + provider.academicTitle) : ""), formatPhone(provider.phone), `./provider?npi=${npi}&deptid=${deptid}&reason=${reason || ''}&backto=${encodeURIComponent(backto) || ''}`);
    } else if (error === "BOOKING_ERROR") {
        content = labels.contactprovider.bookingError;
    } else if (error === "SYSTEM_ERROR") {
        content = labels.contactprovider.systemError(provider.firstName + " " + provider.lastName + (provider.academicTitle ? (", " + provider.academicTitle) : ""), formatPhone(provider.phone), `./provider?npi=${npi}&deptid=${deptid}&reason=${reason || ''}&backto=${encodeURIComponent(backto) || ''}`);
    } else {
        content = labels.contactprovider.currentPatient;
    }

    return (
        <FormWrapper currentStep={0}>
            
            <div className="row errorPage">
                {content}
            </div>
            <div className="row">
                {error === "INVALID_APPT"
                    ? <a className="btn btn-outline-primary mr-3" href={`./provider?npi=${npi}&deptid=${deptid}&reason=${reason || ''}&backto=${encodeURIComponent(backto) || ''}`}>&larr; See available times</a>
                    : <a className="btn btn-outline-primary mr-3" href={`./#reason=${reason}`}>&larr; Start New Search</a>
                }
            </div>
        </FormWrapper>
    );
}

export default ContactProvider;